import { render } from "./Checkmark.vue?vue&type=template&id=74114303&ts=true"
import script from "./Checkmark.vue?vue&type=script&lang=ts"
export * from "./Checkmark.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__